import React from 'react'
import { FeaturesSection } from '../components/Home/FeaturesSection'
import { LastSection } from '../components/Home/LastSection'
import { WelcomeSection } from '../components/Home/WelcomeSection'
import Footer from '../components/Layout/Footer'
import { Navbar } from '../components/Navbar/Navbar'
import { SEO } from '../components/seo'
import { transcriptSeeker } from '../utils/router'

const Home = () => {
    return (
        <main className="snap-mandatory">
            <SEO
                title="Meeting Baas 🐟 | Run your own meeting bots with transcription. In 2 minutes"
                description="Deploy Meeting Bots with transcription. At scale using one API call."
            />
            <div className=" overflow-y-scroll snap-mandatory snap-y h-screen min-h-screen min-w-screen max-w-screen overflow-x-hidden bg-neutral-50">
                <Navbar />
                <WelcomeSection
                    title1="Video, Transcription" // Updated title1
                    title2="and MetaData" // Updated title2
                    title3="using Meeting Bots" // Updated title3
                    subtitle1="Use our Bots as a Service" // Updated subtitle1
                    subtitle2="to collect data on Google Meet, Zoom, and Microsoft Teams" // Updated subtitle2
                    buttonName="Start now" // Updated buttonName
                    secondButtonName="Test in our playground" // Updated buttonName
                    onSecondButtonClick={transcriptSeeker}
                />
                <FeaturesSection />
                <LastSection />
                <div className="snap-start min-w-screen max-w-screen overflow-x-hidden bg-neutral-900">
                    <Footer />
                </div>
            </div>
        </main>
    )
}
export default Home
